import { CountdownPosition, TimerType } from '@/types';

export const COUNTDOWN_POSITION_OPTIONS = [
	{ label: 'Right of title', value: CountdownPosition.RIGHT_OF_TITLE },
	{ label: 'Left of title', value: CountdownPosition.LEFT_OF_TITLE },
	{ label: 'Above title', value: CountdownPosition.ABOVE_TITLE },
	{ label: 'Below title', value: CountdownPosition.BELOW_TITLE },
] as const;

/** Mirrors `COUNTDOWN_POSITION_CLASS` of the storefront script; both renderers share `countdownTimer.css`. */
const COUNTDOWN_POSITION_CLASS: Record<CountdownPosition, string> = {
	[CountdownPosition.RIGHT_OF_TITLE]: 'countdown-position-right',
	[CountdownPosition.LEFT_OF_TITLE]: 'countdown-position-left',
	[CountdownPosition.ABOVE_TITLE]: 'countdown-position-above',
	[CountdownPosition.BELOW_TITLE]: 'countdown-position-below',
};

/** A product container is too narrow to put the counter beside the title, so it starts under it. */
export function getDefaultCountdownPosition(timerType: TimerType): CountdownPosition {
	return timerType === TimerType.PRODUCT_CONTAINER ? CountdownPosition.BELOW_TITLE : CountdownPosition.RIGHT_OF_TITLE;
}

export function getCountdownPositionClass(position: CountdownPosition | undefined): string {
	return (
		COUNTDOWN_POSITION_CLASS[position ?? CountdownPosition.RIGHT_OF_TITLE] ?? COUNTDOWN_POSITION_CLASS.RIGHT_OF_TITLE
	);
}
